import { assertIsNonNegativeNumber } from './assertions';

export default class NonNegativeNumber {
	public get value(): number {
		return this.#value;
	}

	#value: number;
	public constructor(value: number) {
		assertIsNonNegativeNumber(value);
		this.#value = value;
	}
}
